import { useEffect, useRef } from 'react';
import '@splidejs/react-splide/css';
import { useTranslation } from 'react-i18next';

import './stepHeader.css';
import { isIOSVersionHigherThan26Version } from '../../../utils/getUserAgentParser';

export default function StepsHeader({ step, setInvoiceStep, maxStep }) {
    const { t } = useTranslation('basic');
    const isIOS26Version = isIOSVersionHigherThan26Version();

    return (
        <div
            className={`stepsHeaderWrapper gradient_bg_header ${isIOS26Version ? 'ios26_top-safe-area' : ''}`}
            style={{
                paddingBottom: '3.45rem',
            }}
        >
            <div className='stepHeaderHeader heading-h4'>
                {t('tracking_parcel_title')}
                <img
                    id='stepsHeaderImage'
                    src='https://s3.timeweb.com/8a6e091b-publick/tracking_start.png'
                />
            </div>
        </div>
    );
}
